import {
    CalendarAvailabilityAndSessionsDTO,
    CalendarAvailabilityDTO,
    ProfilePictureDTO,
    Therapist,
} from '../model/Types';
import axios from 'axios';
import { authConfig } from '../store/UserStore';
import { BALANCE_PATH_BASE_URL } from './AdminApi';
import { appLanguage } from '../store/LanguageStore';

export const fetchAllProblems = () => {
    return axios.get<string[]>(`${BALANCE_PATH_BASE_URL}/therapist/problems`, {
        headers: {
            'Accept-Language': appLanguage.value?.toLowerCase(),
        },
    });
};

export const fetchTherapistById = (id: number) => {
    return axios.get<Therapist>(`${BALANCE_PATH_BASE_URL}/therapist/${id}`, {
        headers: {
            'Accept-Language': appLanguage.value?.toLowerCase(),
        },
    });
};

export const fetchTherapistByIdAndLanguage = (id: number, languageId: number) => {
    return axios.get<Therapist>(`${BALANCE_PATH_BASE_URL}/therapist/${id}/${languageId}`, {
        headers: {
            'Accept-Language': appLanguage.value?.toLowerCase(),
        },
    });
};

export const fetchTherapistByUsernameAndLanguage = (langId: number, username: string) => {
    return axios.get<Therapist>(`${BALANCE_PATH_BASE_URL}/therapist/user/${langId}/${username}`, {
        headers: {
            'Accept-Language': appLanguage.value?.toLowerCase(),
        },
    });
};

export const getTherapistProfileInfo = () => {
    return axios.get<Therapist>(`${BALANCE_PATH_BASE_URL}/therapist/me`, {
        headers: {
            Authorization: `Bearer ${authConfig.value}`,
            'Accept-Language': appLanguage.value?.toLowerCase(),
        },
    });
};

export const getProfilePicture = (username: string) => {
    return axios.get<ProfilePictureDTO>(
        `${BALANCE_PATH_BASE_URL}/therapist/profile-picture/${username}`,
        {
            headers: {
                Authorization: `Bearer ${authConfig.value}`,
                'Accept-Language': appLanguage.value?.toLowerCase(),
            },
        },
    );
};

export const addTimeSlot = (calendarAvailability: CalendarAvailabilityDTO) => {
    return axios.post<CalendarAvailabilityDTO>(
        BALANCE_PATH_BASE_URL + '/therapist/availability/addTimeSlot',
        calendarAvailability,
        {
            headers: {
                Authorization: `Bearer ${authConfig.value}`,
                'Accept-Language': appLanguage.value?.toLowerCase(),
            },
        },
    );
};

export const getCalendarAvailabilityByTherapistId = (therapistId: number) => {
    return axios.get<CalendarAvailabilityAndSessionsDTO[]>(
        `${BALANCE_PATH_BASE_URL}/therapist/availability/all/${therapistId}`,
        {
            headers: {
                Authorization: `Bearer ${authConfig.value}`,
                'Accept-Language': appLanguage.value?.toLowerCase(),
            },
            params: {
                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            },
        },
    );
};

export const updateAvailability = (id: number, dto: CalendarAvailabilityDTO) => {
    return axios.put(`${BALANCE_PATH_BASE_URL}/therapist/availability/${id}`, dto, {
        headers: {
            Authorization: `Bearer ${authConfig.value}`,
            'Accept-Language': appLanguage.value?.toLowerCase(),
        },
        params: {
            userTimeZone: dto.timeZone,
        },
    });
};

export const deleteCalendarAvailabilityById = (id: number, userTimeZone: string) => {
    return axios.delete(
        `${BALANCE_PATH_BASE_URL}/therapist/availability/deleteCalendarAvailability/${id}`,
        {
            headers: {
                Authorization: `Bearer ${authConfig.value}`,
                'Accept-Language': appLanguage.value?.toLowerCase(),
            },
            params: {
                userTimeZone: userTimeZone,
            },
        },
    );
};
